const NAMESPACE = "graph";

const KEYS = {
    editWidgetOption: "editWidgetOption",
    exportPngBtnLabel: "exportPngBtnLabel",
    exportSvgBtnLabel: "exportSvgBtnLabel",
    deleteBtnLabel: "deleteBtnLabel",
    badGraphMsg: "badGraphMsg"
};

const MESSAGES = {
    [KEYS.editWidgetOption]: { value: "Edit", comment: "Default selection of role to share for drop down list" },
    [KEYS.exportPngBtnLabel]: { value: "Export as PNG", comment: "label for sharing dashboard button" },
    [KEYS.exportSvgBtnLabel]: { value: "Export as SVG", comment: "label for remove button" },
    [KEYS.deleteBtnLabel]: { value: "Delete", comment: "label for delete button" },
    [KEYS.badGraphMsg]: { value: "Bad Graph Type", comment: "Error message for invalid graph type" }
};

export { KEYS, NAMESPACE, MESSAGES };
